export const REGEX = {
  ONLY_LETTERS: /^[aA-zZ\s]+$/,
  CITY_REGEX: /^[a-zA-Z'.\-\s]+$/,
};

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
